import { lazy, Suspense, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, Switch } from "react-router-dom";
import { useGlobalContext } from "../../context/globalContext";
import { useCreditInfoStepsContext } from "../../context/creditInfoStepsContext";
import Steps from "../../shared/steps/steps";
import Loader from "../../shared/loaders/simpleLoader";
import useServiceType from "../../hooks/useServiseType";
import { SERVICE_TYPES } from "../../utils/constants/fieldErrors";

const Agreement = lazy(() =>
  import("../../components/creditInfoForm/steps/agreement")
);
const Step2 = lazy(() => import("../../components/creditInfoForm/steps/step2"));
const Step3 = lazy(() => import("../../components/creditInfoForm/steps/step3"));
const Step4 = lazy(() => import("../../components/creditInfoForm/steps/step4"));
const Step5 = lazy(() => import("../../components/creditInfoForm/steps/step5"));

export function CreditInfoStepRoutes() {
  const { steps, activeStep, setActiveStep } = useCreditInfoStepsContext();
  const { i18n } = useTranslation();
  const { serviceType } = useServiceType();
  const {
    globalData: { status },
  } = useGlobalContext();

  const isApproved = useMemo(() => status !== "Approved", [status]);

  return (
    <Steps
      steps={steps}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      hideSteps={serviceType !== SERVICE_TYPES.creditInfoForm && true}
    >
      <Suspense fallback={<Loader />}>
        {isApproved ? (
          <Switch>
            <Route
              component={Agreement}
              path={`/creditinfo/agreement/:mobile?/${i18n.language}`}
            />
            <Route
              component={Step2}
              path={`/creditinfo/Identomat/${i18n.language}`}
            />
            <Redirect to={`/creditinfo/agreement/${i18n.language}`} />
          </Switch>
        ) : (
          <Switch>
            <Route component={Step3} path={`/creditinfo/step/3`} />
            <Route component={Step4} path={`/creditinfo/step/4`} />
            <Route component={Step5} path={`/creditinfo/step/5`} />
            <Redirect to={`/creditinfo/step/3`} />
          </Switch>
        )}
      </Suspense>
    </Steps>
  );
}
